'use client';

import ArticleCard from '@/features/article/components/article-card';
import type { MediaAuthorArticleListItem } from '@/features/media-authors/types';
import { MEDIA_AUTHORS_INTERACTIVE_CARD_LINK_CLASS } from '@/features/media-authors/styles/media-authors-card-shadow';
import { useMediaAuthorArticles } from '@/features/media-authors/hooks/use-media-author-articles';
import { MediaAuthorArticlesHeader } from './media-author-articles-header';
import { toArticleCardModel } from './media-author-articles.utils';

type MediaAuthorArticlesProps = {
  readonly slug: string;
  readonly initialDocs: MediaAuthorArticleListItem[];
  readonly initialHasNextPage: boolean;
  readonly articlesCount: number;
};

/**
 * Published articles grid for a media author page (infinite scroll, no sort select).
 */
export const MediaAuthorArticles = ({
  slug,
  initialDocs,
  initialHasNextPage,
  articlesCount,
}: MediaAuthorArticlesProps) => {
  const { articles, isLoading, hasNextPage, sentinelRef } = useMediaAuthorArticles({
    slug,
    initialDocs,
    initialHasNextPage,
  });
  return (
    <section className="mx-auto mt-4 max-w-[1260px] px-4 pb-12 md:mt-8 md:pb-16">
      <MediaAuthorArticlesHeader articlesCount={articlesCount} />
      {articles.length === 0 ? (
        <p className="text-[#6E7384]">Пока нет опубликованных статей.</p>
      ) : (
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {articles.map((item) => (
            <ArticleCard
              key={item.id}
              article={toArticleCardModel(item)}
              size="small"
              cardClassName={MEDIA_AUTHORS_INTERACTIVE_CARD_LINK_CLASS}
            />
          ))}
        </div>
      )}
      {hasNextPage ? <div ref={sentinelRef} className="h-8" aria-hidden /> : null}
      {isLoading ? <p className="mt-4 text-sm text-[#6E7384]">Загрузка…</p> : null}
    </section>
  );
};
